import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormPostalCodeField } from './KioskFormPostalCodeField/KioskFormPostalCodeField';
import { WebFormPostalCodeField } from './WebFormPostalCodeField/WebFormPostalCodeField';
import { FormPostalCodeFieldProps } from './FormPostalCode.types';

const FormPostalCodeField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.AlphanumericNumpad,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
}: FormPostalCodeFieldProps) => {
    return isElectron() ? (
        <KioskFormPostalCodeField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            onChangeCallback={onChangeCallback}
        />
    ) : (
        <WebFormPostalCodeField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            onChangeCallback={onChangeCallback}
        />
    );
});

export default FormPostalCodeField;